export default "__VITE_ASSET__Cm3mNUXK__"